import PropTypes from 'prop-types';

/**
 * i18n is defined in redux locale.js
 */
export const i18nShape = PropTypes.shape({
  locale: PropTypes.string.isRequired,
  messages: PropTypes.objectOf(PropTypes.any).isRequired,
});

export const intlShape = PropTypes.shape({
  locale: PropTypes.string.isRequired,
  timeZone: PropTypes.string,
  formatMessage: PropTypes.func.isRequired,
  formatHTMLMessage: PropTypes.func.isRequired,
  formatDate: PropTypes.func.isRequired,
});

export const locationShape = PropTypes.objectOf(PropTypes.any);
export const historyShape = PropTypes.objectOf(PropTypes.any);
/**
 * React router match.
 */
export const matchShape = PropTypes.shape({
  params: PropTypes.objectOf(PropTypes.any).isRequired,
});

export const growlShape = PropTypes.shape({
  show: PropTypes.func.isRequired,
  showAnyGraphQlErrors: PropTypes.func.isRequired,
});

export const formikFormShape = PropTypes.shape({
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
});

export const formikFieldShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
});

/**
 * Shape for objects we usually pass when we use `useMutation`.
 */
export const useMutationShape = PropTypes.shape({
  mutation: PropTypes.func.isRequired,
  result: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]).isRequired,
});

export const connectionShape = PropTypes.shape({
  edges: PropTypes.arrayOf(PropTypes.any).isRequired,
});
